import { FC, PropsWithChildren } from 'react';

const PageTitle: FC<PropsWithChildren<{
  size?: 'small' | 'medium' | 'large',
  className?: string,
}>> = ({
  children,
  size = 'large',
  className = '',
}) => !children
  ? null
  : (
    <h2 className={`
       font-semibold leading-[1.2em] text-text sm:truncate sm:tracking-tight
      ${{
        small: 'text-lg',
        medium: 'text-2xl',
        large: 'text-3xl',
      }[size]}
      ${className}
    `}>
      {children}
    </h2>
  );

export default PageTitle;
